import React from 'react'
import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { SECTION } from 'utils/section'
import { scrollTo } from 'utils/scrollTo'
import styles from './Hero.module.scss'

export const Hero = () => {
  const { t } = useTranslation()
  return (
    <section className={styles['section']}>
      <div className={styles['container']}>
        <div className={styles['content']}>
          <h1>{t('hero.title')}</h1>
          <p>{t('hero.description')}</p>
          <NavLink className={styles['button']} to="/" onClick={() => scrollTo(SECTION.CONCEPT)}>{t('hero.learnMore')}</NavLink>
        </div>
      </div>
    </section>
  )
}
